import { Flex } from "@chakra-ui/layout";
import { Collapse } from "@chakra-ui/react";
import CheckboxFiltro from "components/inputs/checkbox-filtro";
import RadioFiltro from "components/inputs/radio-filtro";
import {
  ConcentracaoColheitaOcupacao,
  NumeroDeAplicacoesOcupacoes,
  OperacoesExecutadasOcupacoes,
} from "features/maps/typings";
import { OcupacaoEnum } from "features/maps/enums";
import { OcupacaoETecnologiasReturnProps } from "core/features/talhoes/typings/ocupacaoETenologias";

type Item = { id: string; nome: string; enabled?: boolean };

interface OcupacoesButtonsProps {
  items:
  | OperacoesExecutadasOcupacoes[]
  | NumeroDeAplicacoesOcupacoes[]
  | ConcentracaoColheitaOcupacao[]
  | OcupacaoETecnologiasReturnProps["ocupacoes"];
  onChange: (value: OcupacaoEnum) => void;
  value: OcupacaoEnum;
  tecnologiasValue?: string[];
  tecnologiasItems?: Item[];
  onChangeTecnologias?: (v?: any) => void;
  isMultipleChanges?: boolean;
}

const OcupacoesButtons = ({
  items,
  value,
  onChange,
  tecnologiasValue = [],
  tecnologiasItems = [],
  onChangeTecnologias,
  isMultipleChanges,
}: OcupacoesButtonsProps) => {

  const enabledItems = items?.filter(item => item.enabled);

  return (
    <Flex
      flex={1}
      ml={2}
      flexDir="column"
    >
      {enabledItems?.map((item, index) => (
        <Flex
          key={index}
          flex={1}
          mb={1}
          flexDir="column"
        >
          <Flex
            flex={1}
            alignItems="center"
            mb={1}
          >
            <RadioFiltro
              isChecked={value === item.codigo}
              text={item.nome}
              onClick={() => {
                if (value !== item.codigo) {
                  onChange(item.codigo);
                }
              }}
            />
          </Flex>
          <Collapse in={value === item.codigo}>
            <Flex
              flex={1}
              mb={1}
              pl={8}
              flexDir="column"
            >
              <CheckboxFiltro
                isChecked={tecnologiasValue.length >= tecnologiasItems.length}
                text="Todos"
                onClick={() => {
                  if (onChangeTecnologias) {
                    if (isMultipleChanges) {
                      onChangeTecnologias(tecnologiasItems.map((t) => t.id));
                    } else {
                      onChangeTecnologias();
                    }
                  }
                }}
              />
              {tecnologiasItems.map((tecnologia, index) => (
                <CheckboxFiltro
                  key={index}
                  isChecked={tecnologiasValue.includes(tecnologia.id)}
                  text={tecnologia.nome}
                  onClick={() => {
                    if (onChangeTecnologias) {
                      if (isMultipleChanges) {
                        if (tecnologiasValue.includes(tecnologia.id)) {
                          if (tecnologiasValue.length > 1) {
                            onChangeTecnologias(tecnologiasValue.filter((_v) => _v !== tecnologia.id));
                          }
                        } else {
                          onChangeTecnologias([...tecnologiasValue, tecnologia.id]);
                        }
                      } else {
                        onChangeTecnologias(tecnologia.id);
                      }
                    }
                  }}
                />
              ))}
            </Flex>
          </Collapse>
        </Flex>
      ))}
    </Flex>
  );
};

export default OcupacoesButtons;
